import React, { useEffect } from 'react'
import XfinityTable from '../../Components/XfinityTable/page'
import Banner2 from '../../Components/Banner/Banner2'

const Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Banner2 title="WELCOME TO XFINITY SERIES" backgroundImage="/assets/images/banner/video-banner-1.jpg"/>
    <XfinityTable/>
    </>
  )
}

export default Page